import type {
  GetApiV1ListIdRefereeParams,
  GetApiV1ListParams,
} from '@1webit/cvs-api-scheme/models';
import { queryOptions } from '@tanstack/react-query';

import type { ListType } from '@/app/(dashboard)/lists/browse/page';
import { DEFAULT_TABLE_PAGE_SIZE } from '@/constants';
import { getResponse, queryParams } from '@/utils';

export const getApiV1ListIdReferee = (listId: number, page = 1, limit = DEFAULT_TABLE_PAGE_SIZE, sort?: string, params?: GetApiV1ListIdRefereeParams) => queryOptions({
  queryKey: ['getApiV1ListIdReferee', listId, page, limit, sort, params],
  queryFn: () => getResponse('getApiV1ListIdReferee', listId, queryParams({
    ...params,
    sort,
    offset: (page - 1) * limit,
    limit,
  })),
});

export const getApiV1ListUser = (page = 1, limit = DEFAULT_TABLE_PAGE_SIZE, sort?: string) => queryOptions({
  queryKey: ['getApiV1ListUser', page, limit, sort],
  queryFn: () => getResponse('getApiV1ListUser', queryParams({
    offset: (page - 1) * limit,
    limit,
    sort,
  })),
});
export const getApiV1ListAll = (page = 1, limit = 200, params: { matchId: number }, sort?: string) => queryOptions({
  queryKey: ['getApiV1ListAll', page, limit, sort, params],
  queryFn: () => getResponse('getApiV1ListAll', queryParams({
    offset: (page - 1) * limit,
    limit,
    sort,
    ...params,
  })),
});

export const getApiV1ListArchivedQueryOptions = () => queryOptions({
  queryKey: ['getApiV1ListArchived'],
  queryFn: () => getResponse('getApiV1ListArchived'),
});

export const getApiV1ListId = (listId: number) => queryOptions({
  queryKey: ['getApiV1ListId', listId],
  queryFn: () => getResponse('getApiV1ListId', listId),
});

export const getApiV1ListIdRefereeHistory = (listId: number, page = 1, limit = DEFAULT_TABLE_PAGE_SIZE, sort?: string) => queryOptions({
  queryKey: ['getApiV1ListIdRefereeHistory', listId, page, limit, sort],
  queryFn: async () => getResponse('getApiV1ListIdRefereeHistory', listId, queryParams({
    offset: (page - 1) * limit,
    limit,
    sort,
  })),
});

export const getApiV1ListIdRefereeVersion = (listId: number, page = 1, limit = DEFAULT_TABLE_PAGE_SIZE, sort?: string) => queryOptions({
  queryKey: ['getApiV1ListIdRefereeVersion', listId, page, limit, sort],
  queryFn: async () => getResponse('getApiV1ListIdRefereeVersion', listId, queryParams({
    offset: (page - 1) * limit,
    limit,
    sort,
  })),
});

export const getApiV1ListIdRefereeArchive = (listId: number, datetime: string, page = 1, limit = DEFAULT_TABLE_PAGE_SIZE, sort?: string) => queryOptions({
  queryKey: ['getApiV1ListIdRefereeArchive', listId, datetime, page, limit, sort],
  queryFn: async () => getResponse('getApiV1ListIdRefereeArchive', listId, queryParams({
    datetime,
    offset: (page - 1) * limit,
    limit,
    sort,
  })),
});

export const getApiV1ListByCategory = (listType: ListType) => queryOptions({
  queryKey: ['getApiV1ListByCategory', listType],
  queryFn: () => getResponse('getApiV1ListByCategory', { type: listType }),
});

/**
 * Gets user list detail
 * @param listId
 * @param userId
 */
export const getApiV1ListIdRefereeUserIdDetail = (listId: number, userId: number, page = 1, limit = DEFAULT_TABLE_PAGE_SIZE, sort?: string) => queryOptions({
  queryKey: ['getApiV1ListIdRefereeUserIdDetail', listId, userId, page, limit, sort],
  queryFn: () => getResponse('getApiV1ListIdRefereeUserIdDetail', listId, userId, queryParams({
    offset: (page - 1) * limit,
    limit,
    sort,
  })),
});

export const getApiV1List = (params?: GetApiV1ListParams) => queryOptions({
  queryKey: ['getApiV1List', params],
  queryFn: async () => getResponse('getApiV1List', queryParams({ ...params })),
});

/**
 * Gets list user rights
 * @param listId
 */
export const getApiV1ListUserRights = (listId: number) => queryOptions({
  queryKey: ['getApiV1ListUserRights', listId],
  queryFn: () => getResponse('getApiV1ListUserRights', { listId }),
});

/**
 * Gets list column options
 */
export const getApiV1ListColumnOptions = queryOptions({
  queryKey: ['getApiV1ListColumnOptions'],
  queryFn: () => getResponse('getApiV1ListColumnOptions'),
});

export const getApiV1ListIdDetail = (listId: number) => queryOptions({
  queryKey: ['getApiV1ListIdDetail', listId],
  queryFn: () => getResponse('getApiV1ListIdDetail', listId),
});

export const getApiV1ListFilterList = (type?: string) => queryOptions({
  queryKey: ['getApiV1ListFilterList', type],
  queryFn: () => getResponse('getApiV1ListFilterList', queryParams({ type })),
});
